import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { useFlag } from '@calendly/feature-check-react'

import { useProfile } from 'components/use_profile'
import { autofillDataSelector } from 'selectors/scheduling'
import {
  isPollSelector
} from 'selectors/event_type'
import { spotsParamSelector } from 'selectors'
import { isReschedulingSelector } from 'selectors/current_invitee'
import { getSalt } from 'services/request_id'

import ReschedulingForm from './rescheduling_form'
import SchedulingForm from './scheduling_form'
import SchedulingFormV2 from './scheduling_form_feature'

const BookingForm = () => {
  const match = useRouteMatch()
  const autofillData = useSelector(autofillDataSelector)
  const isRescheduling = useSelector(isReschedulingSelector)
  const isPoll = useSelector(isPollSelector)
  const { spotStartTime } = match.params
  const requestKeySalt = getSalt()
  const spotStartTimes = useSelector(spotsParamSelector)
  const profile = useProfile()
  const sbSchedulingFormV2Enabled = useFlag('sb_scheduling_form_v2', false)
  const asyncBookingEnabled = useFlag('scheduling_platform_async_booking', false)

  const renderSchedulingForm = () => (
    (
      sbSchedulingFormV2Enabled
        ? (
          <SchedulingFormV2
            spotStartTime={spotStartTime}
            spotStartTimes={spotStartTimes}
            autofillData={autofillData}
            requestKeySalt={requestKeySalt}
            isPoll={isPoll}
            profile={profile}
            asyncBookingEnabled={asyncBookingEnabled}
          />
        ) : (
          <SchedulingForm
            spotStartTime={spotStartTime}
            spotStartTimes={spotStartTimes}
            autofillData={autofillData}
            requestKeySalt={requestKeySalt}
            isPoll={isPoll}
            profile={profile}
          />
        )
    )
  )
  return (isRescheduling ? (
    <ReschedulingForm
      spotStartTime={spotStartTime}
      autofillData={autofillData}
      requestKeySalt={requestKeySalt}
    />
  )
    : (renderSchedulingForm())
  )
}

export default BookingForm
